module.exports = __webpack_public_path__ + "img/default.0c14bc04.jpg";